import { Pipe, PipeTransform } from '@angular/core';
import { Stay } from '@shared/models';
import { max } from 'date-fns';

@Pipe({
  name: 'nearestStayStartDate'
})
export class NearestStayStartDatePipe implements PipeTransform {

  transform(stay: Stay): Date {
    const today = new Date();
    if (!stay?.startDateAsObject) return today;
    return max([today, stay.startDateAsObject]);
  }

}
